import Vue from "vue";

export default Vue.extend({
  name: "TimeInput",
  props: ["value", "onChange", "onBlur", "title", "error"],
});
